import { Component, computed, inject, Signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../components/content/content.component';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../../services/ssession.service';
import { ServiceListItem } from '../../../services/service.common.model';
import { AlertComponent } from '../../../common/alert/alert.component';
import { TabViewComponent } from '../../../common/tab-view/tab-view.component';
import { TabPanelComponent } from '../../../common/tab-view/tab-panel.component';

@Component({
  selector: 'app-application-info-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    CommonModule,
    RouterModule,
    AlertComponent,
    TabViewComponent,
    TabPanelComponent
  ],
  templateUrl: './application-info-page.component.html'
})
export class ApplicationInfoPageComponent {

  public route: ActivatedRoute = inject(ActivatedRoute);

  public applicationInfo: Signal<ServiceListItem | undefined> = toSignal((this.route.data as any).pipe(map((v: {
    applicationInfo: ServiceListItem | null
  }) => v.applicationInfo)));

  public authed: boolean = SessionService.Authed();

  public completedData: boolean = !!SessionService.GetTokenData()?.email;

  isTabContent = computed(() => {
    const url = this.applicationInfo()?.url || '';
    return ['/przeksztalcenie-prawa-wieczystego-uzytkowania', '/zezwolenie-sprzedaz-napojow-alkoholowych'].includes(url);
  });

  tabContent: Signal<Array<{ name: string, content: string }>> = computed(() => {
    return JSON.parse(this.applicationInfo()?.content || '');
  });

}
